module.exports = __webpack_public_path__ + "img/cart-plus-fill.48f38b25.svg";